<app-section-layout (onIntersection)="onIntersection($event)" [itemTemplate]="productionKpiGraph" [dataForChart]="graphData" ></app-section-layout>

<ng-template #productionKpiGraph let-data="data" let-sectionNavState="sectionNavState">
    <app-production-kmt-slide  [intersection]="intersection$" [productionKpiGraph]="data.graph.data" [navState] = "sectionNavState"></app-production-kmt-slide>
</ng-template>